import { render, staticRenderFns } from "./readonly-checkbox.vue?vue&type=template&id=70084613&scoped=true&"
import script from "./readonly-checkbox.vue?vue&type=script&lang=js&"
export * from "./readonly-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70084613",
  null
  
)

export default component.exports